import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { MatPaginator, MatTable, MatTableDataSource } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Vistoria } from '@tivic-team/manager-ts/dist/mob/entities/vistoria/vistoria.entity';
import { VistoriaSituacaoLabels } from '@tivic-team/manager-ts/dist/mob/enums/vistoria/vistoria-situacao.enum';
import { ConcessaoService } from 'app/services/mob/concessao.service';
import { VistoriaSearch } from 'app/services/mob/vistoria.search';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'grid-vistoria',
  templateUrl: './grid-vistoria.component.html',
  styleUrls: ['./grid-vistoria.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class GridVistoriaComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatTable, { static: true }) dataTable: MatTable<Vistoria>;

  @Output() onFind: EventEmitter<VistoriaSearch> = new EventEmitter();

  pageSize: number = 10;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['situacao', 'agendadoPara', 'aplicadaEm', 'vistoriador'];
  formGroup: FormGroup;
  cdConcessao: number;

  constructor(
    private _concessaoService: ConcessaoService,
    private _control: ControlContainer,
    private _activatedRoute: ActivatedRoute
    ) { }

  ngOnInit() {
    this.formGroup = this._control.control as FormGroup;
    this.cdConcessao = +this._activatedRoute.snapshot.params['cdConcessao'];
    this.load();
  }

  load(){
    if (this.cdConcessao > 0){
      this._concessaoService.getVistorias(this.cdConcessao).then( r => {
        this.dataSource = new MatTableDataSource(r);
        this.dataSource.paginator = this.paginator;
      });
    }
  }

  public _getSituacaoVistoriaLabelFunction(column, register: Vistoria){
    if(register.stVistoria !== undefined) return VistoriaSituacaoLabels.get(register.stVistoria);
    
      return '';
  }

}
